define('frontend-common-components/utils/utils',[
], function() {
    var utils = {};
    utils.isIE = function() {
    	return ('ActiveXObject' in window);
    };
    return utils;
});
